package nl.volleyplanner.web.controller.userprofile

import kotlinx.browser.document
import kotlinx.coroutines.flow.StateFlow
import kotlinx.html.*
import kotlinx.html.dom.create
import kotlinx.html.js.div
import nl.volleyplanner.api.auth.AuthLevel
import nl.volleyplanner.web.base.*
import nl.volleyplanner.web.service.WebUserAndOrganisationService
import nl.volleyplanner.web.util.BootstrapColor
import org.w3c.dom.HTMLElement


class OrganisationDetailsComponent() : HTMLComponent() {

    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        val organisationContext = WebUserAndOrganisationService.selectedOrganisationState.value
        val organisation = WebUserAndOrganisationService.selectedOrganisationState.value?.organisation

        return consumer.div {
            if (organisationContext == null || organisation == null) {
                spinner()
            } else {
                h2 {
                    icon("bi-house-door", color = BootstrapColor.Primary, useMargin = true)
                    +organisation.name
                }

                div (classes = "card shadow-sm mt-2") {
                    div (classes = "card-body") {
                        h5 (classes = "card-title") {
                            img (classes = "me-1") {
                                style = "height: 1em;"
                                src = "/img/logo-nevobo.png"
                                alt = "Nevobo"
                            }
                            +"vereniging"
                        }
                        div {
                            if (organisation.linkedClub == null) {
                                +"Geen vereniging gekoppeld, contact Volleyplanner op info@volleyplanner.nl"
                            } else {
                                div (classes = "fw-semibold fs-5") {
                                    +organisation.linkedClub!!.name
                                }
                                div (classes = "small text-muted") {
                                    val nevoboUrl = "https://www.volleybal.nl/competitie/vereniging/${organisation.linkedClub!!.clubId}"
                                    a (classes = "text-decoration-none") {
                                        href = nevoboUrl
                                        target = "_blank"

                                        icon("bi-link-45deg", color = BootstrapColor.Primary)
                                        +nevoboUrl
                                    }
                                }
                            }
                        }
                    }
                }

                component(ManageUsersComponent())
            }
        }
    }

    override suspend fun getState(): StateFlow<*> = WebUserAndOrganisationService.selectedOrganisationState
}

class VerenigingBeheerController : RootPageController() {
    override val name: String = "VerenigingBeheerController"
    override val path: String = "/beheer"
    override val requiredAuthLevel: AuthLevel = AuthLevel.AdminUser
    override val childPages: List<WebPageController> = emptyList()

    override val title: String = "Beheer vereniging"

    override fun createRuntimeInstance() = VerenigingBeheerController()

    override suspend fun renderContent(): HTMLElement {
        return document.create.div {
            component(OrganisationDetailsComponent())
        }
    }
}